export enum FeatureToggle {
  PAYMENT = 'feature_payment',
  SIGNUP_SUNSET = 'feature_signup_sunset',
  SLACK = 'feature_slack',
  LANDING = 'feature_landing',
  DECISION_RECORDS = 'feature_decision_records',
}
